define('app/views/tickets_passengers_info_view',['app/setup'], function (takhfifan) {
  takhfifan.TicketsPasengersInfo = takhfifan.BaseView.extend({
    events: {
      "submit": "submitForm",
      "change input#same-data": "toggleSecondFormView"
    },

    initialize: function () {
      var _this = this;
      this.$submitBtn = this.$('button[type="submit"]');
      this.url = this.$el.prop('action');
      this.method = this.$el.prop('method');
      this.successMessage = "اوکی ....";
      this.duplicateData = this.$("#same-data").length && this.$("#same-data").is(':checked');

      this.$el.find('input[required]').on('change invalid', function() {
        if($(this).prop('type')==='radio'){
          return;
        }
        var inputField = $(this).get(0);

        inputField.setCustomValidity('');

        if (!inputField.validity.valid) {
          var fieldName = $(this).data('name');
          inputField.setCustomValidity('لطفا ' + fieldName + ' را وارد کنید');
        }
      });
      this.enableForm();
      //convert numbers for this class to english
      $( ".tkh-persian-number-converter" ).change(function(e) {
        var engNumberConverted=_this.toEnglishNumber($(e.target).val());
        $(e.target).val(engNumberConverted);

      });
    },
    // english number converter
    toEnglishNumber:function (strNum) {
      var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
          en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
          an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
          cache = strNum;

      for (var i = 0; i < 10; i++) {
        var regex_fa = new RegExp(pn[i], 'g'),
            regex_ar = new RegExp(an[i], 'g');

        cache = cache.replace(regex_fa, en[i]);
        cache = cache.replace(regex_ar, en[i]);
      }
      return cache;
    },

    enableForm: function(){
      this.$el.removeClass('loading-view');
      this.$submitBtn.removeAttr("disabled");
    },

    disableForm: function () {
      this.$el.addClass('loading-view');
      this.$submitBtn.prop("disabled", "disabled");
    },

    toggleSecondFormView: function (e) {
      var $target=$(e.target),
          $wrapper = $target.parents('.tkh-ticket-passenger-form__item');
      if($target.is(':checked')){
        $wrapper.addClass('form-page__wrapper--same-option');
        $wrapper.find('fieldset input').prop('disabled','disabled');
        this.duplicateData = true;
      }else{
        $wrapper.removeClass('form-page__wrapper--same-option');
        $wrapper.find('input[disabled]').removeProp('disabled');
        this.duplicateData = false;
      }
    },

    getFormData: function () {
      var _this = this,
          data = {};

      data['form_key'] = takhfifan.formKey;
      data['order_hash'] = this.$('input[name="order-hash"]').val();
      data['mobile_number'] = this.$('#mobile-number').val();

      data['items'] = [];
      this.$('.tkh-ticket-passenger-form__item').each(function () {
        var $this = $(this),
            passengers = [];

        if($this.hasClass('form-page__wrapper--same-option')){
          return true;
        }

        $this.find('fieldset').each(function(){
          var $fieldSet = $(this);
          passengers.push({
            firstname: $fieldSet.find('input[name|="name"]').val(),
            lastname: $fieldSet.find('input[name|="surname"]').val(),
            national_id: $fieldSet.find('input[name|="ncode"]').val(),
            birthday: $fieldSet.find('select[name|="birth_year"]').val() +"-"+$fieldSet.find('select[name|="birth_month"]').val()+"-"+$fieldSet.find('select[name|="birth_day"]').val(),
            gender: $fieldSet.find('input[name|="gender"]:checked').val()
          })
        });

        data['items'].push({
          'item_id': $(this).data("id"),
          'passengers':passengers
        });

        if(_this.duplicateData){
          data['items'].push({
            'item_id': $this.siblings('.form-page__wrapper--same-option').data("id"),
            'passengers':passengers
          });
        }

      });

      return data;
    },

    submitForm: function (e) {
      e.preventDefault();
      var _this = this;

      var formData = this.getFormData();
      $.ajax({
        url: _this.url,
        type: _this.method,
        data: formData
      }).done(function (data) {
        if (data.success) {
          takhfifan.eventHub.trigger(
            'confirm:showMessage',
            {
              msg: i18n.t('train_sending_success'),
              type: 'success',
              btnTxt: 'تایید'
            });
          _this.$el[0].reset();
          _this.$el.css('display','none');
          _this.$el.next('.form-message').css('display','block');
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        }
      }).fail(function () {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: "در برقراری ارتباط خطایی پیش آمد"
        });
      }).always(function () {
        _this.enableForm();
      });
    }

  });
});

